<section class="kanban-page">
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>

  <header class="kanban-toolbar">
    <div>
      <h1>Канбан</h1>
      <span class="tasks-total">{{ loading ? 'Обновляем задачи...' : tasks.length + ' задач' }}</span>
    </div>
    <button class="primary-button" type="button" (click)="openCreate()">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
      <span>Добавить задачу</span>
    </button>
  </header>

  <section class="kanban-board" aria-label="Доска задач">
    <article
      *ngFor="let column of columns"
      class="kanban-column"
      [class]="'kanban-column tone-' + column.tone"
      [class.drag-over]="dragOverStatus === column.status"
      (dragover)="onDragOver($event, column.status)"
      (dragleave)="dragOverStatus = null"
      (drop)="onDrop($event, column.status)"
    >
      <header class="column-header">
        <div>
          <span class="column-marker"></span>
          <h2>{{ column.label }}</h2>
          <b>{{ getColumnTasks(column.status).length }}</b>
        </div>
      </header>

      <div class="task-stack">
        <article
          *ngFor="let task of getColumnTasks(column.status); trackBy: trackById"
          class="task-card"
          [class.moving]="movingTaskId === task.id"
          draggable="true"
          (dragstart)="onDragStart($event, task)"
          (dragend)="onDragEnd()"
        >
          <div class="task-card-head">
            <div class="task-tags" *ngIf="task.tags.length">
              <span *ngFor="let tag of task.tags" [class]="'task-tag tone-' + getTagTone(tag)">{{ tag }}</span>
            </div>
            <button class="icon-button delete" type="button" title="Удалить задачу" aria-label="Удалить задачу" (click)="deleteTask(task)">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="m19 6-1 14H6L5 6"/></svg>
            </button>
          </div>

          <h3>{{ task.title }}</h3>
          <p *ngIf="task.description">{{ task.description }}</p>

          <footer class="task-card-footer">
            <span class="priority-pill" [class]="'priority-pill priority-' + task.priority">{{ getPriorityName(task.priority) }}</span>
            <span class="due-date" *ngIf="task.dueDate">
              <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/></svg>
              {{ formatDueDate(task.dueDate) }}
            </span>
            <select class="task-status-select" [value]="task.status" [attr.aria-label]="'Переместить задачу «' + task.title + '»'" (change)="moveTask(task, getStatusFromEvent($event))">
              <option *ngFor="let targetColumn of columns" [value]="targetColumn.status">{{ targetColumn.label }}</option>
            </select>
          </footer>
        </article>

        <div class="empty-column" *ngIf="getColumnTasks(column.status).length === 0">Перетащите задачу сюда</div>
      </div>
    </article>
  </section>

  <div class="modal-backdrop" *ngIf="modalOpen">
    <section class="task-modal" role="dialog" aria-modal="true" aria-label="Новая задача">
      <header class="modal-header">
        <h2>Новая задача</h2>
        <button class="icon-button" type="button" title="Закрыть" aria-label="Закрыть" (click)="closeModal()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m18 6-12 12"/><path d="m6 6 12 12"/></svg>
        </button>
      </header>

      <form class="task-form" (ngSubmit)="saveTask()">
        <label class="wide">
          <span>Название</span>
          <input class="form-control" name="taskTitle" [(ngModel)]="formData.title" placeholder="Например, подготовить отчет по матчам" required>
        </label>
        <label class="wide">
          <span>Короткое описание</span>
          <textarea class="form-control" name="taskDescription" [(ngModel)]="formData.description" rows="3" placeholder="Что нужно сделать"></textarea>
        </label>
        <label>
          <span>Приоритет</span>
          <select class="form-select" name="taskPriority" [(ngModel)]="formData.priority">
            <option *ngFor="let option of priorityOptions" [ngValue]="option.value">{{ option.label }}</option>
          </select>
        </label>
        <label>
          <span>Колонка</span>
          <select class="form-select" name="taskStatus" [(ngModel)]="formData.status">
            <option *ngFor="let column of columns" [ngValue]="column.status">{{ column.label }}</option>
          </select>
        </label>
        <label>
          <span>Дата</span>
          <input class="form-control" type="date" name="taskDueDate" [(ngModel)]="formData.dueDate">
        </label>
        <label>
          <span>Теги</span>
          <input class="form-control" name="taskTags" [(ngModel)]="tagsInput" placeholder="backend, frontend">
        </label>
        <div class="modal-actions wide">
          <button class="secondary-button" type="button" (click)="closeModal()">Отмена</button>
          <button class="primary-button" type="submit" [disabled]="saving">{{ saving ? 'Сохраняем...' : 'Добавить задачу' }}</button>
        </div>
      </form>
    </section>
  </div>
</section>
